import { gql } from '@apollo/client';

import { ProfessorActivity } from '../../types';
import { professorActivityFragment } from '../fragments';

export interface ToggleActivityMutationVariables {
  courseId: string;
  activityId: string;
  status: string;
}

export interface ToggleActivityMutationResult {
  activity: ProfessorActivity;
}

export const toggleActivityMutation = gql`
  mutation DeleteActivity($courseId: String!, $activityId: String!, $status: Boolean) {
    activity(courseId: $courseId, activityId: $activityId, status: $status, input: {})
      @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}/{args.status}", method: "PUT") {
      ...ProfessorActivity
    }
  }
  ${professorActivityFragment}
`;
